module.exports = __webpack_public_path__ + "assets/img/20-s.aa68303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/20-s.jpg
// module id = Vgsb
// module chunks = 0